const { COMPATIBLE_CREDENTIAL_TYPES, CREDENTIAL_TYPE_TEMPLATES } = require('./constants');

const templateTypes = new Set([...Object.keys(CREDENTIAL_TYPE_TEMPLATES)]);

/**
 * Determine whether the credential is changing to a newly templated type which is incompatible with the existing type.
 * If so, this will require us to delete all existing credential tokens and create a new set of credentials.
 * @param newType
 * @param existingType
 * @returns {boolean}
 */
const isDestructiveCredentialTypeChange = (newType, existingType) =>
  newType &&
  existingType !== newType &&
  templateTypes.has(newType) &&
  !COMPATIBLE_CREDENTIAL_TYPES[newType]?.includes(existingType);

module.exports = {
  isDestructiveCredentialTypeChange
};
